import { defineChain as viemDefineChain } from 'viem'

import type { AppChain } from './chain.types'

const viemHyperevm = viemDefineChain({
  id: 999,
  name: 'HyperEVM',
  nativeCurrency: {
    name: 'Hyperliquid',
    symbol: 'HYPE',
    decimals: 18
  },
  rpcUrls: {
    default: { http: ['https://rpc.hyperliquid.xyz/evm'] }
  },
  blockExplorers: {
    default: { name: 'HyperEVMScan', url: 'https://hyperevmscan.io' }
  },
  contracts: {
    multicall3: {
      address: '0xca11bde05977b3631167028862be2a173976ca11',
      blockCreated: 13051
    }
  }
})

export const hyperevm = {
  ...viemHyperevm,
  custom: {
    name: 'HyperEVM',
    shortName: 'Hyperevm',
    morphoChainSlug: 'hyperevm',
    hasFullSupport: true,
    blockExplorer: { name: 'HyperEVMScan', baseUrl: 'https://hyperevmscan.io' },
    contracts: {
      v1: {
        AdaptiveCurveIrm: {
          address: '0xD4a426F010986dCad727e8dd6eed44cA4A9b7483',
          startBlock: 1988429n
        },
        MorphoBlue: { address: '0x68e37dE8d93d3496ae143F2E900490f6280C57cD', startBlock: 1988429n },
        MetaMorphoV11Factory: {
          address: '0xec051b19d654C48c357dC974376DeB6272f24e53',
          startBlock: 1988677n
        }
      },
      v2: {
        VaultV20Factory: {
          address: '0xD7217E5687FF1071356C780b5fe4803D9D967da7',
          startBlock: 14188393n
        },
        MorphoMarketV1AdapterFactory: {
          address: '0xc6b8B565C715134b0Ca3D6fa3D29B25759D0b9e2',
          startBlock: 14188393n
        },
        MorphoMarketV1AdapterV2Factory: {
          address: '0xaEff6Ef4B7bbfbAadB18b634A8F11392CBeB72Be',
          startBlock: 21460330n
        },
        MorphoVaultV1AdapterFactory: {
          address: '0xdf5202e29654e02011611A086f15477880580CAc',
          startBlock: 14188393n
        },
        RegistryList: {
          address: '0x857B55cEb57dA0C2A83EE08a8dB529B931089aee',
          startBlock: 14188698n
        },
        BluePublicAllocator: {
          address: '0x056dd7D4B373ED26c788190085CC6C52B8e7479d',
          startBlock: 43372279n
        }
      }
    }
  }
} as const satisfies AppChain<{ v1: true; v2: true }>
